import ButtonLoadingContent from '../../../shared/Loading/ButtonLoadingContent';

const RoleForm = ({ name, onChange, onSave, onClose, loading, mode }) => {
  return (
    <div className="p-5">
      <div className="mb-4">
        <label className="mb-1 block text-sm font-medium text-gray-700">
          Nombre del rol
        </label>
        <input
          type="text"
          name="Name"
          value={name}
          onChange={onChange}
          disabled={loading}
          className="w-full rounded border border-gray-300 px-3 py-2 text-sm outline-none focus:border-personalized"
          placeholder="Escribe el nombre del rol"
        />
      </div>
      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="rounded border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed"
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={onSave}
          disabled={loading}
          className={`rounded px-4 py-2 text-sm text-white ${
            loading
              ? 'bg-purple-200 cursor-not-allowed'
              : 'bg-personalized hover:opacity-90'
          }`}
        >
          <ButtonLoadingContent loading={loading}>
            {mode === 'create' ? 'Crear rol' : 'Guardar cambios'}
          </ButtonLoadingContent>
        </button>
      </div>
    </div>
  );
};

export default RoleForm;
